<template lang='pug' src='./custom-home-welcome.pug'></template>

<script>
import ModalVideo from 'components/modal/modal-video/modal-video'
import SliderHome from 'components/slider/slider-home/slider-home'

export default {
  props: ['props'],
  data () {
    return {
      titleActive: false,
      active: false,
      showVideoModal: false
    }
  },
  methods: {
    displayVideoModal () {
      this.showVideoModal = true
      this.showVideoModal ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    hideVideoModal () {
      this.showVideoModal = false
      this.showVideoModal ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    }
  },
  components: {
    ModalVideo,
    SliderHome
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-welcome.vue?361cb2b4